import {useRoute} from '@react-navigation/native';
import {Div, HeaderBack, TimeLine} from 'components';
import {Ecolors} from 'constant';
import React, {useState} from 'react';
import OrderBuyBounty from './OrderBuyBounty';

function CreateOrderBuyBountyScreen() {
  const route = useRoute<any>();
  const orderType: 'BUY' | 'SELL' | 'TRANSFER' = route.params?.orderType;
  const initData: any = route.params?.initData;
  const [stepTimeLine, setStepTimeLine] = useState<number>(1);
  return (
    <Div screen={true} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={`eventreward.datlenhmuavoitienthuong`} />
      <TimeLine index={stepTimeLine} />
      <OrderBuyBounty
        initData={initData}
        stepTimeLine={stepTimeLine}
        setStepTimeLine={setStepTimeLine}
      />
    </Div>
  );
}

export default React.memo(CreateOrderBuyBountyScreen);
